module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "todo-display"
  }, [_c('div', {
    staticClass: "todo-view"
  }, _vm._l((_vm.sortedDates), function(date) {
    return _c('div', {
      key: date,
      staticClass: "tw-day"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filteredTodos(date).length),
        expression: "filteredTodos(date).length"
      }],
      staticClass: "date-info",
      class: {
        today: date === _vm.getTodayDate
      }
    }, [_c('em', [_vm._v(_vm._s(_vm.getDayDiff(date)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(date))])]), _vm._v(" "), _c('todo-list', {
      attrs: {
        "todos": _vm.filteredTodos(date)
      }
    })], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15b8530a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/todoView.vue
// module id = 32
// module chunks = 0